import React, {Component} from 'react';
import _ from 'lodash';
import Scene from '../Scene'
class Timeline extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modelActive: 0,
            modelsLength: 0,
            playing: false
        }
        this.animate;
    }
    onChange(e){
        this.props.onChange(e);
    }
    showModel(e) {
        this.setState({ modelActive: Number(e.target.value) })
        this.props.activateModel(e.target.value)
    }
    playTimeline(){
        if(this.state.playing){
            clearInterval(this.animate)
            this.setState({playing: false});
            return false
        }
        const self =  this;
        this.setState({playing: true})
        if( self.state.modelActive === self.state.modelsLength ){
            self.setState({ modelActive: 0 })
            self.showModel({ target: { value: 0 }})

        }
        this.animate = setInterval(()=>{
            if(self.state.modelActive !== self.state.modelsLength){
                let i = Number(self.state.modelActive + 1);
                self.setState({ modelActive: i })
                self.showModel({ target: { value: i }})

            }else{
                clearInterval(this.animate);
                this.setState({playing: false});
            }
        } , 300);
    }
    stepForward(){
        if(this.state.modelActive === this.state.modelsLength){
            return false
        }
        let i = Number(this.state.modelActive + 1);
        this.setState({ modelActive: i })
        this.showModel({ target: { value: i }})
    }
    stepBackward(){
        if(this.state.modelActive === 0){
            return false
        }
        let i = Number(this.state.modelActive - 1);
        this.setState({ modelActive: i })
        this.showModel({ target: { value: i }})
    }
    fastBackward(){
        if(this.state.modelActive === 0){
            return false
        }
        let i = 0;
        this.setState({ modelActive: i })
        this.showModel({ target: { value: i }})
    }
    fastForward(){
        if(this.state.modelActive === this.state.modelsLength){
            return false
        }
        let i = Number(this.state.modelsLength);
        this.setState({ modelActive: i })
        this.showModel({ target: { value: i }})
    }
    goToFrame(e){
        // if(this.state.modelActive === this.state.modelsLength){
        //     return false
        // }
        let i = Number(e.target.id);
        this.setState({ modelActive: i })
        this.showModel({ target: { value: i }})
    }
    componentWillReceiveProps(nextProps) {
        let modelsL = nextProps.timelineLength ? (nextProps.timelineLength.length/2)-1 : 0;
        this.setState({modelsLength: modelsL});
    }
    renderFrames(){
        let frames = []
        for (let i = 0; i <= this.state.modelsLength; i++) {
            frames.push(<li key={i}>
                <span className={this.state.modelActive === i ? "active" : ""} onClick={this.goToFrame.bind(this)} id={i}>{i}</span>
            </li>)
        }
        return frames
    }
    render() {
        let playStyle = this.state.playing ? "fa fa-pause" : "fa fa-play";
        return (
            <div
                className="timeline col-md-12 d-flex justify-content-between"
            >
                <div className="timeline-controls">
                    <button
                        className="btn btn-sm btn-secondary"
                        id="top"
                        onClick={this.fastBackward.bind(this)}
                    >
                        <i className="fa fa-fast-backward" />
                    </button>
                    <button
                        className="btn btn-sm btn-secondary"
                        id="top"
                        onClick={this.stepBackward.bind(this)}
                    >
                        <i className="fa fa-step-backward" />
                    </button>
                    <button
                        className="btn btn-sm btn-secondary"
                        id="top"
                        onClick={this.playTimeline.bind(this)}
                    >
                        <i className={playStyle} />
                    </button>
                    <button
                        className="btn btn-sm btn-secondary"
                        id="top"
                        onClick={this.stepForward.bind(this)}
                    >
                        <i className="fa fa-step-forward" />
                    </button>
                    <button
                        className="btn btn-sm btn-secondary"
                        id="top"
                        onClick={this.fastForward.bind(this)}
                    >
                        <i className="fa fa-fast-forward" />
                    </button>
                </div>
                <div className="timeline-slider range">
                    <input
                        className="timeline-range"
                        ref="timeline"
                        value={this.state.modelActive}
                        type="range"
                        min="0"
                        max={this.state.modelsLength}
                        onChange={this.showModel.bind(this)}
                    />
                    <ul className="list-unstyled timeline-frames d-flex justify-content-between">
                        {this.renderFrames()}
                    </ul>
                </div>
            </div>
        )
    }
}
export default Timeline;


// WEBPACK FOOTER //
// ./resources/assets/js/components/viewer/Timeline.jsx